import logo from "../logo.svg";
import { Link } from "react-router";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router";
import { useContext } from "react";
import { LoggedInContext } from "../App";
import { ThemeButtonAccountBG } from "./Config";

export default function NavBar() {
  //
  //get ai detector values
  // eslint-disable-next-line no-unused-vars
  const { isLoggedIn, setIsLoggedIn } = useContext(LoggedInContext);

  //handle click
  const handleClickLoginButton = () => {
    navigate("/login"); //Navigate to new route
  }; //handle button click

  //handle click
  const handleClickSignUpButton = () => {
    navigate("/signup"); //Navigate to new route
  }; //handle button click

  //react router navigate
  const navigate = useNavigate(); //react router navigate

  return (
    <nav className="navbar fixed-top navbar-expand-lg  navbar-light bg-light">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">
          <img
            src={logo}
            alt=""
            width="36"
            height="36"
            className="d-inline-block align-text-center mb-1"
          />
          <h3 className="d-inline-block align-text-center ms-2">
            Humanize Texts
          </h3>
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
          <div className="navbar-nav d-flex justify-content-end w-100">
            {/* Pricing */}
            <NavLink
              className={`nav-link mx-2 ${(e) => {
                return e.isActive() ? "active" : "";
              }}`}
              style={{ color: "red" }}
              to="/pricing"
            >
              Pricing
            </NavLink>

            {/* API */}
            <NavLink
              className={`nav-link mx-2 ${(e) => {
                return e.isActive() ? "active" : "";
              }}`}
              to="/api"
            >
              API (Coming Soon)
            </NavLink>

            {/* AI Detector */}
            <li className="nav-item mx-2 dropdown">
              <label
                className="nav-link dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                AI Detector
              </label>
              <ul className="dropdown-menu">
                <li>
                  <Link className="dropdown-item" to="/ai-detector">
                    AI Texts Detector
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/ai-image-detector">
                    AI Images/Photo Detector
                  </Link>
                </li>
              </ul>
            </li>

            {/* Humanize Texts */}
            <NavLink
              className={`nav-link mx-2 ${(e) => {
                return e.isActive() ? "active" : "";
              }}`}
              to="/"
            >
              Humanize Texts
            </NavLink>

            {/* Text Summarizer */}
            <NavLink
              className={`nav-link mx-2 ${(e) => {
                return e.isActive() ? "active" : "";
              }}`}
              to="/text-summarizer"
            >
              Summarizer
            </NavLink>

            {/* Paraphraser */}
            <NavLink
              className={`nav-link mx-2 ${(e) => {
                return e.isActive() ? "active" : "";
              }}`}
              to="/plagiarism-checker"
            >
              Plagiarism Checker
            </NavLink>

            {/* Paraphraser */}
            <NavLink
              className={`nav-link mx-2 ${(e) => {
                return e.isActive() ? "active" : "";
              }}`}
              to="/paraphrase"
            >
              Paraphraser
            </NavLink>

            {/* History */}
            <NavLink
              className={`nav-link mx-2 ${
                isLoggedIn.is_logged_in ? "" : "d-none"
              } ${(e) => {
                return e.isActive() ? "active" : "";
              }}`}
              to="/history"
            >
              History
            </NavLink>

            {/* User account div */}
            <div>
              {/* Login Signup button */}
              <div
                className={`${isLoggedIn.is_logged_in ? "d-none" : "d-flex"}`}
              >
                <button
                  className="btn btn-primary me-2 mb-2"
                  type="button"
                  onClick={handleClickLoginButton}
                  role="link"
                >
                  Log In
                </button>
                <button
                  className="btn btn-warning me-2 mb-2"
                  type="button"
                  onClick={handleClickSignUpButton}
                  role="link"
                >
                  Sign Up
                </button>
              </div>

              {/* User account div */}
              <div
                className={`${
                  isLoggedIn.is_logged_in === false ? "d-none" : "d-flex"
                } justify-content-center`}
              >
                <button
                  className="btn btn-clear text-light"
                  style={{ backgroundColor: ThemeButtonAccountBG }}
                  type="button"
                  onClick={(e) => {
                    //blur
                    e.target.blur();
                    //navigate to accounts page
                    navigate("/myaccount");
                  }}
                >
                  My Account
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
